import axios from 'axios';
import Product from '../../models/Product';

const state = function () {
    return {
        selected: [],
        applyToAllResults: false,
        ids: [],
        filters: {
            brand: null,
            provider: null,
            category: null,
            query: null
        },
        order: [{
            value: 'id',
            sort: 'desc'
        }],
        items: [],
        limit: 50,
        currentPage: 1,
        page: 1,
        totalItems: 999999,
        fetchRoute: null,
        loader: false
    };
};

const mutations = {
    SET_ITEMS(state, data) {
        state.items = Product.build(data);
    },
    UPDATE_ITEM(state, {
        id,
        data
    }) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        if( index != -1 ) {
            state.items[index] = state.items[index].update(data);
        } else {
            console.error('Indx not found for id : '+id);
        }
    },
    REMOVE_ITEM(state, id) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        state.items.splice(index, 1);
    },
    SET_META(state, data) {
        state.totalItems = data.total;
        state.limit = data.per_page;
    },
    SET_FILTERS(state, data) {
        for (var filter in data) {
            state.filters[filter] = data[filter]
        }
    },
    SET_ORDER(state, data) {
        state.order = [data]
    },
    SET_FETCH_ROUTE(state, data) {
        state.fetchRoute = data
    },
    SET_PAGE(state, data) {
        state.page = data
    },
    SET_APPLY_TO_ALL_RESULTS(state, data) {
        state.applyToAllResults = data
    },
    SET_LOADER(state, data) {
        state.loader = data
    },
    SET_IDS(state, data) {
        state.ids = data
    }
};

const actions = {
    resetFilters({
        commit
    }) {
        commit('SET_FILTERS', {
            brand: null,
            provider: null,
            category: null,
            query: null
        })
    },
    setFilters({
        commit
    }, data) {
        commit('SET_FILTERS', data)
        return dispatch('fetch')
    },
    setOrder({
        commit,
        dispatch
    }, data) {
        commit('SET_ORDER', data)
        return dispatch('fetch')
    },
    setPage({
        commit
    }, data) {
        commit('SET_PAGE', data)
        return dispatch('fetch')
    },
    setFetchRoute({
        commit
    }, data) {
        commit('SET_FETCH_ROUTE', data)
    },
    updateInList({
        commit,
        state
    }, {
        id,
        data
    }) {
        commit('UPDATE_ITEM', {
            id,
            data
        })
    },
    removeInList({
        commit
    }, id) {
        commit('REMOVE_ITEM', id)
    },
    setItems({commit}, data) {
        commit('SET_ITEMS', data)
    },
    fetch({
        commit,
        state
    }, params) {
        let mergedParams = {
            /*
            filters: state.filters,
            order: state.order,
            limit: state.limit,
            page: state.page,
            */
            ...params
        }
        return axios.post('/catalog', mergedParams ).then((r) => {
            commit('SET_ITEMS', r.data.data)
            commit('SET_META', r.data.meta)
            if(r.data.ids) {
                commit('SET_IDS', r.data.ids)
            }
        })
    },
    fetchDuplicate({
        commit,
        state
    }, params) {
        let mergedParams = {
            /*
            filters: state.filters,
            order: state.order,
            limit: state.limit,
            page: state.page,
            */
            ...params
        }
        return axios.get('/duplicate', {
            params: mergedParams
        }).then((r) => {
            commit('SET_ITEMS', r.data.data)
            commit('SET_META', r.data.meta)
        })
    },
    review({
        commit,
        state
    }, params) {
        let mergedParams = {
            /*
            filters: state.filters,
            order: state.order,
            limit: state.limit,
            page: state.page,
            */
            ...params
        }
        return axios.get('/review', {
            params: mergedParams
        }).then((r) => {
            commit('SET_ITEMS', r.data.data)
            commit('SET_META', r.data.meta)
        })
    },
    comarchReview({
        commit,
        state
    }, params) {
        let mergedParams = {
            /*
            filters: state.filters,
            order: state.order,
            limit: state.limit,
            page: state.page,
            */
            ...params
        }
        return axios.get('/comarch-review', {
            params: mergedParams
        }).then((r) => {
            commit('SET_ITEMS', r.data.data)
            commit('SET_META', r.data.meta)
        })
    },
    setApplyToAllResults({
        commit
    }, data) {
        commit('SET_APPLY_TO_ALL_RESULTS', data)
    },
    setLoader({
        commit
    }, data) {
        commit('SET_LOADER', data)
    },
};

const getters = {
    selected: (state) => state.selected,
    order: (state) => state.order,
    items: (state) => state.items,
    limit: (state) => state.limit,
    currentPage: (state) => state.currentPage,
    totalItems: (state) => state.totalItems,
    filters: (state) => state.filters,
    applyToAllResults: (state) => state.applyToAllResults,
    loader: (state) => state.loader,
    ids: (state) => state.ids,
};

let moduleStore = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default moduleStore;
